<script>
  import { modal } from 'vue-strap';

  export default {
    components: { modal },
    props: ['mostrar', 'itens', 'solicitacao', 'carregando'],
    computed: {
      show() {
        return this.mostrar;
      }
    },
    methods: {
      cancelado(item, etapa) {
        if (etapa <= 2)
            if (item.liberadoCoordenador === 3) 
                return true;

        if (etapa <= 3)
            if (item.canceladoCompra) 
                return true;
        
        if (etapa <= 5)
            if (item.cancelado) 
                return true;

        return false;
      },
      statusItem(item) {
        if (item.dataRecebimentoCoordenador) {
            return 7;
        } else if (item.dataEntregaFornecedor) {
            return 6;
        } else if (item.numeroPedidoCompra) {
            return 5;
        } else if (item.solicitacaoCompra || item.codigoLicitacao) {
            return 4;
        } else if (item.canceladoCompra) {
            return 3;
        } else if (item.liberadoCoordenador) {
            return 2;
        } else {
            return 1;
        }
      },
      totalEstimado(quantidade, valorEstimado) {
        if (valorEstimado === '') {
          return '---';
        }

        return this.$options.filters.formatarNumero(quantidade * valorEstimado);
      },
      formatarValorEstimado(valorEstimado) {
        return this.$options.filters.formatarNumero(valorEstimado || 0);
      },
    }
  }
</script>

<style scoped>
    .cancelado {
        background: #ed5565;
    }
</style>


<template>
  <div>
    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="$emit('fechado')"
           :large="true"
           :title="`Status dos itens da solicitação ${solicitacao ? solicitacao.idSolicitacaoCompra : ''}`">

        <div class="text-center" v-if="carregando">
          <i class='fa fa-spinner fa-pulse'></i> Carregando...
        </div>

        <div slot="modal-header" class="modal-header">
          <div class="row">
            <div class="col-xs-12">
              <table class="table no-margins text-left">
                <tr>
                  <td>1 - Solicitação recebida</td>
                  <td>2 - Liberado/Cancelado - Coordenador</td>
                  <td>3 - Liberado/Cancelado - Fundação</td>
                </tr>
                <tr>
                  <td>4 - Gerado compra/licitação</td>
                  <td>5 - Pedido enviado para o fornecedor</td>
                  <td>6 - Pedido entregue pelo fornecedor</td>
                </tr>
                <tr>
                  <td>7 - Pedido entregue ao coordenador</td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div v-for="(item, index) in itens">
          <div class="statusItem">
            <div :class="[statusItem(item) >= 1 ? 'circle-filled' : 'circle', {'cancelado': cancelado(item,1)}]" v-tooltip="'Solicitação recebida'"></div>
            <div :class="[statusItem(item) >= 2 ? 'bar-filled' : 'bar', {'cancelado': cancelado(item,2)}]"></div>
            <div :class="[statusItem(item) >= 2 ? 'circle-filled' : 'circle', {'cancelado': cancelado(item,2)}]" v-tooltip="'Liberado/Cancelado - Coordenador'"></div>
            <div :class="[statusItem(item) >= 3 ? 'bar-filled' : 'bar', {'cancelado': cancelado(item,3)}]"></div>
            <div :class="[statusItem(item) >= 3 ? 'circle-filled' : 'circle', {'cancelado': cancelado(item,3)}]" v-tooltip="'Liberado/Cancelado - Fundação'"></div>
            <div :class="[statusItem(item) >= 4 ? 'bar-filled' : 'bar', {'cancelado': cancelado(item,4)}]"></div>
            <div :class="[statusItem(item) >= 4 ? 'circle-filled' : 'circle', {'cancelado': cancelado(item,4)}]" v-tooltip="'Gerado compra/licitação'"></div>
            <div :class="[statusItem(item) >= 5 ? 'bar-filled' : 'bar', {'cancelado': cancelado(item,5)}]"></div>
            <div :class="[statusItem(item) >= 5 ? 'circle-filled' : 'circle', {'cancelado': cancelado(item,5)}]" v-tooltip="'Pedido enviado para o fornecedor'"></div>
            <div :class="[statusItem(item) >= 6 ? 'bar-filled' : 'bar']"></div>
            <div :class="[statusItem(item) >= 6 ? 'circle-filled' : 'circle']" v-tooltip="'Pedido entregue pelo fornecedor'"></div>
            <div :class="[statusItem(item) >= 7 ? 'bar-filled' : 'bar']"></div>
            <div :class="[statusItem(item) >= 7 ? 'circle-filled' : 'circle']" v-tooltip="'Pedido entregue ao coordenador'"></div>
          </div>

          <dl>
            <dt>Descrição</dt>
            <dd>{{ item.nomeProduto }} - {{ item.descricao }}</dd>
          </dl>

          <div class="row">
            <dl class="col-xs-3">
              <dt>Quantidade</dt>
              <dd>{{ item.quantidade || '---' }}</dd>
            </dl>
            <dl class="col-xs-3">
              <dt>Unidade</dt>
              <dd>{{ item.unidade || '---' }}</dd>
            </dl>
            <dl class="col-xs-3">
              <dt>Valor estimado (R$)</dt>
              <dd>{{ item.valorEstimado ? formatarValorEstimado(item.valorEstimado) : '---' }}</dd>
            </dl>
            <dl class="col-xs-3">
              <dt>Total estimado do item (R$)</dt>
              <dd>{{ totalEstimado(item.quantidade, item.valorEstimado) }}</dd>
            </dl>
          </div>

          <div class="row">
            <dl class="col-xs-3">
              <dt>Sol. compra</dt>
              <dd>{{ item.solicitacaoCompra || '---' }}</dd>
            </dl>
            <dl class="col-xs-3">
              <dt>Licitação</dt>
              <dd>{{ item.codigoLicitacao || '---' }}</dd>
            </dl>
            <dl class="col-xs-3">
              <dt>Pedido</dt>
              <dd>{{ item.numeroPedidoCompra || '---' }}</dd>
            </dl>
            <dl class="col-xs-3">
              <dt>Cancelado no pedido?</dt>
              <dd>{{ item.cancelado ? 'Sim' : 'Não' }}</dd>
            </dl>
          </div>

          <div class="row">
              <dl class="col-xs-6">
                  <dt>Responsável pela compra</dt>
                  <dd>{{ item.responsavelCompra || '---' }}</dd>
              </dl>
              <dl class="col-xs-3">
                  <dt>Sol. web</dt>
                  <dd>{{ item.solicitacaoWeb || '---' }}</dd>
              </dl>
              <dl class="col-xs-3">
                  <dt>Conta a pagar</dt>
                  <dd>{{ item.contaPagarCriada > 0 ? 'Sim' : 'Não' }}</dd>
              </dl>
          </div>

          <div class="row" v-if="item.dataRecebimentoCoordenador">
              <dl class="col-xs-5">
                  <dt>Data recebimento coordenador</dt>
                  <dd>{{ item.dataRecebimentoCoordenador | formatarNumeroEmData }}</dd>
              </dl>
              <dl class="col-xs-7">
                  <dt>Recebido por</dt>
                  <dd>{{ item.recebidoPor || '---' }}</dd>
              </dl>
          </div>

          <div class="hr-line-dashed" v-if="index !== itens.length - 1"></div>
        </div>

        <div slot="modal-footer" class="modal-footer">
          <div class="row">
            <div class="col-xs-12">
              <table class="table no-margins text-left">
                <tr>
                  <td>1 - Solicitação recebida</td>
                  <td>2 - Liberado/Cancelado - Coordenador</td>
                  <td>3 - Liberado/Cancelado - Fundação</td>
                  <td rowspan="3" class="text-right">
                    <button type="button" class="btn btn-default" @click="$refs.modal.action(false, 3)">
                      <i class="fa fa-times"></i> Fechar
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>4 - Gerado compra/licitação</td>
                  <td>5 - Pedido enviado para o fornecedor</td>
                  <td>6 - Pedido entregue pelo fornecedor</td>
                </tr>
                <tr>
                  <td>7 - Pedido entregue ao coordenador</td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
    </modal>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/ModalStatusItem.vue